module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("attach_file")]), _vm._v("\n    Documents\n  ")], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.documents && _vm.documents.length > 0) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Attached documents")]), _vm._v(" "), _vm._l((_vm.documents), function(doc, index) {
    return [_c('v-list-tile', {
      key: ("doc-" + (doc.name) + "-" + index),
      attrs: {
        "href": doc.file,
        "target": "_blank"
      }
    }, [_c('v-list-tile-avatar', [_c('v-btn', {
      attrs: {
        "loading": doc.deleting === true,
        "color": "error",
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.confirmDeleteFile = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "300"
      },
      model: {
        value: (_vm.confirmDeleteFile),
        callback: function($$v) {
          _vm.confirmDeleteFile = $$v
        },
        expression: "confirmDeleteFile"
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "subheading"
    }, [_vm._v("\n                Are you sure you want to delete this file?\n              ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "text": ""
      },
      on: {
        "click": function($event) {
          _vm.confirmDeleteFile = false
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "loading": _vm.deleting,
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(doc, index)
        }
      }
    }, [_vm._v("Delete")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "mr-2",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(doc.id) + ". " + _vm._s(doc.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (doc.name) + "-" + index)
    })]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.documents && _vm.documents.length > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Upload documents")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "filepicker grey lighten-3 pa-3",
    attrs: {
      "type": "file",
      "id": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.setFiles
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.files) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.files), function(file, index) {
    return _c('v-list-tile', {
      key: ((file.name) + "-" + index)
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("cloud_upload")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(file.name))])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.files.length === 0,
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.clearfiles
    }
  }, [_vm._v("Clear files")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.uploading,
      "disabled": _vm.files.length === 0,
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tc('upload.button', _vm.files.length, {
    n: _vm.files.length
  })) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-797f49df","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/edit/DocumentList.vue
// module id = 1474
// module chunks = 9